/**
 * @typedef {Object} TeamMember
 * @property {string} id
 * @property {string} name
 * @property {string} role
 * @property {string} bio
 * @property {string} pillar
 */

/** @type {TeamMember[]} */
export const teamData = [
  {
    id: 'team-president',
    name: 'President — ATN',
    role: 'President & Chief Steward',
    bio: 'Provides visionary leadership, upholds the servant-steward covenant, and champions continental transformation through YALS and strategic partnerships.',
    pillar: 'Executive Leadership',
  },
  {
    id: 'team-vp-programs',
    name: 'Vice President, Programs',
    role: 'Programs & Formation',
    bio: 'Oversees YALS curriculum delivery, masterclasses, learning circles, and accountability structures across cohorts.',
    pillar: 'Young African Leaders Scheme',
  },
  {
    id: 'team-secretary',
    name: 'Secretary General',
    role: 'Governance & Documentation',
    bio: 'Maintains policy compliance, board records, and non-partisan governance standards for all network initiatives.',
    pillar: 'Governance',
  },
  {
    id: 'team-treasurer',
    name: 'Treasurer',
    role: 'Financial Stewardship',
    bio: 'Ensures transparent stewardship of resources supporting community projects, events, and leadership formation.',
    pillar: 'Stewardship',
  },
  {
    id: 'team-tech-lead',
    name: 'Director, Technology & Innovation',
    role: 'Tech & Immersive Learning',
    bio: 'Leads digital platforms, metaverse learning pilots, and innovation pipelines for scalable continental impact.',
    pillar: 'Technology & Innovation',
  },
  {
    id: 'team-community-lead',
    name: 'Director, Community Development',
    role: 'Community & Volunteer Afrik',
    bio: 'Coordinates continental community projects, volunteer mobilization, and grassroots partnership models.',
    pillar: 'Community Development',
  },
];

export const servantLeadershipExcerpt =
  'People matter before positions. Growth is intentional. Leadership is stewardship — a covenant to serve communities, multiply mentors, and build Africa with faith, integrity, and excellence. ATN remains strictly non-partisan in political and governance development.';
